import React, { useEffect, useRef, useImperativeHandle, forwardRef, memo } from 'react';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJTab.module.less';
import useLocalStore from '../../../hooks/useLocalStore';
import FJConstant from '../../../constants/FJConstant';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import FJEvent from '../../../store/FJEvent.js';

// 自适应宽度的tab组件

const Item = forwardRef((props, ref) => {
    const {
        isSelected,
        text,
        icon,
        onClick,
        className,
        selectClassName,
        textClassName,

        gradationClassName,
        gradationContentClassName,
        gradationActiveClassName,
        isGradationBorder,
    } = props;
    const box = useRef();
    useImperativeHandle(ref, () => ({
        getItemBoundRect: () => {
            return {
                x: box.current.offsetLeft,
                y: box.current.offsetTop,
                width: box.current.offsetWidth,
                height: box.current.offsetHeight,
            };
        },
    }));

    return (
        <div
            ref={box}
            onClick={onClick}
            className={classNames(
                styles.item,
                className,
                isSelected ? (selectClassName ? selectClassName : styles.isSelected) : '',
            )}
        >
            {isGradationBorder ? (
                <FJHoverBoardGradation
                    active={isSelected}
                    className={classNames(gradationClassName, isSelected && gradationActiveClassName)}
                    contentClassName={gradationContentClassName}
                >
                    <>
                        {icon ? <div className={styles.icon}>{icon}</div> : null}
                        {text ? (
                            <span className={classNames(styles.text, textClassName)}>{FJLocalStore._(text)}</span>
                        ) : null}
                    </>
                </FJHoverBoardGradation>
            ) : (
                <>
                    {icon ? <div className={styles.icon}>{icon}</div> : null}
                    {text ? (
                        <span className={classNames(styles.text, textClassName)}>{FJLocalStore._(text)}</span>
                    ) : null}
                </>
            )}
        </div>
    );
});

const FJTab = (props, ref) => {
    useLocalStore();
    const {
        dataList = [],
        selectedIndex = -1,
        space = 10,
        onChange,
        selectClassName,
        itemClass,
        lineClass,
        textClassName,

        isGradationBorder = false,
        gradationContentClassName,
        gradationClassName,
        gradationActiveClassName,
    } = props;
    const _languageChanged = useRef(0);

    const line = useRef();
    const selectedTab = useRef(null);

    useEffect(() => {
        return FJEvent.subscribe(FJConstant.LANGUAGE_CHANGED, () => {
            _languageChanged.current++;
        });
    }, []);

    useEffect(() => {
        if (line.current && selectedTab.current) {
            const rect = selectedTab.current.getItemBoundRect();
            const left = rect.x;
            const width = rect.width;
            line.current.style.left = left + 'px';
            line.current.style.width = width + 'px';
        }
    }, [selectedIndex, _languageChanged.current]);

    useImperativeHandle(ref, () => {
        return {
            getSelectedItemRect: () => {
                return selectedTab.current ? selectedTab.current.getItemBoundRect() : null;
            },
        };
    });

    const _onChange = index => {
        if (onChange) onChange(index);
    };

    return (
        <div className={styles.box} style={{ gap: space }}>
            {dataList.map((item, index) => {
                const { type, text, icon } = item;
                const isSelected = index === selectedIndex;
                return (
                    <Item
                        key={type + index}
                        ref={isSelected ? selectedTab : null}
                        className={itemClass}
                        isSelected={isSelected}
                        text={text}
                        icon={icon}
                        onClick={e => _onChange(index)}
                        selectClassName={selectClassName}
                        textClassName={textClassName}
                        isGradationBorder={isGradationBorder}
                        gradationClassName={gradationClassName}
                        gradationActiveClassName={gradationActiveClassName}
                        gradationContentClassName={gradationContentClassName}
                    />
                );
            })}
            <div ref={line} className={classNames(styles.line, lineClass)} />
        </div>
    );
};

export default memo(forwardRef(FJTab));
